export default function localBusinessSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": "https://www.sujaramahaenterprises.com/#localbusiness",

        "name": "Sujaramaha Enterprises",
        "url": "https://www.sujaramahaenterprises.com",

        /* ✅ Use array for multiple phone numbers */
        "telephone": [
            "+91-94483-44445",
            "+91-99724-65259"
        ],

        /* ✅ FIXED: Proper PostalAddress */
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Vadanakal, Pavagada",
            "addressLocality": "Pavagada",
            "addressRegion": "KA",
            "postalCode": "561202",
            "addressCountry": "IN"
        },

        /* ✅ ADD AggregateRating here (fixes Google error) */
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "120"
        },

        "openingHoursSpecification": [
            {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                "opens": "09:00",
                "closes": "19:00"
            }
        ],

        "sameAs": [
            "https://www.facebook.com/share/16mturVQZw/",
            "https://www.instagram.com/sujaramahaenterprises",
            "https://www.youtube.com/@SUJARAMAHAENTERPRISE",
            "https://share.google/fnzQG4UH25xKQFChg"
        ]
    };
}
